import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AppProvider } from '@shopify/polaris';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import enTranslations from '@shopify/polaris/locales/en.json';
import '@shopify/polaris/build/esm/styles.css';

import { AppFrame } from './components/AppFrame';
import Dashboard from './pages/Dashboard';
import Products from './pages/Products';
import Links from './pages/Links';
import Analytics from './pages/Analytics';
import Calls from './pages/Calls';
import Ally from './pages/Ally';
import Settings from './pages/Settings';
import Billing from './pages/Billing';

// Create a client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
    },
  },
});

function App() {
  // Get URL parameters
  const searchParams = new URLSearchParams(window.location.search);
  const host = searchParams.get('host');
  const shop = searchParams.get('shop');
  const idToken = searchParams.get('id_token');
  const embedded = searchParams.get('embedded');

  // Valid Shopify session if we have host OR (id_token AND embedded=1)
  const hasValidSession = host || (idToken && embedded === '1');

  // If no valid session parameters, show error or redirect to install
  if (!hasValidSession) {
    return (
      <AppProvider i18n={enTranslations}>
        <div style={{ padding: '2rem', textAlign: 'center' }}>
          <h1>App Installation Required</h1>
          <p>Please install this app through the Shopify App Store.</p>
          {shop && (
            <p style={{ marginTop: '1rem' }}>
              <a href={`/auth?shop=${shop}`}>Click here to install</a>
            </p>
          )}
        </div>
      </AppProvider>
    );
  }

  return (
    <AppProvider i18n={enTranslations}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AppFrame shop={shop}>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/app" element={<Dashboard />} />
              <Route path="/products" element={<Products />} />
              <Route path="/links" element={<Links />} />
              <Route path="/analytics" element={<Analytics />} />
              <Route path="/calls" element={<Calls />} />
              <Route path="/ally" element={<Ally />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/billing" element={<Billing />} />
              <Route path="/billing/confirm" element={<Billing />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </AppFrame>
        </BrowserRouter>
      </QueryClientProvider>
    </AppProvider>
  );
}

export default App;
